import React from 'react';
import FlagRuleDetailSection from '../../../sections/AdminDashboard/Configuration/FlagRuleDetail';

const FlagRuleDetail = () => <FlagRuleDetailSection />;

export default FlagRuleDetail;
